export default __webpack_public_path__ + "static/media/guests-tab.9fcfbc4c.png";